import React from 'react'

/**
 * Hides Intercom.
 */
export default function hideIntercom (Target) {
  return class IntercomHider extends React.Component {
    componentDidMount () {
      document.body.classList.add('hide-intercom')
    }

    componentWillUnmount () {
      document.body.classList.remove('hide-intercom')
    }

    render () {
      return (
        <Target {...this.props} />
      )
    }
  }
}



// WEBPACK FOOTER //
// ./src/client/decorators/hideIntercom.js